import dayjs from 'dayjs';

export function setInterceptors(instance) {
	// Add a request interceptor
	instance.interceptors.request.use(
		function (config) {
			// Do something before request is sent
			// config.headers.Authorization = store.state.token;
			config.headers['Accept-Language'] = 'ko_KR';
			return config;
		},
		function (error) {
			// Do something with request error
			return Promise.reject(error);
		},
	);

	// Add a response interceptor
	instance.interceptors.response.use(
		function (response) {
			// Any status code that lie within the range of 2xx cause this function to trigger
			// Do something with response data
			return response;
		},
		function (error) {
			// Any status codes that falls outside the range of 2xx cause this function to trigger
			// Do something with response error
			error.response.data.resultTs = dayjs(error.response.data.resultTs).format(
				'YYYY-MM-DD HH:mm:ss',
			);
			return error.response;
		},
	);
	return instance;
}
